<template>
    <div class="modal-dialog" :style="{zIndex: modalStyleIndex}">
            <div v-if="isOpen" @click="onClicking" id="customModal" class="relative">
                <div @click="closeOnBackdropClick ? () => changeModalState(false) : undefined" :class="`modal-backdrop`"></div>
                    <div id="staticModal" tabindex="-1" aria-hidden="true" :class="`${modalClass} fixed top-0 left-0 right-0 z-50  w-full p-4 overflow-hidden md:inset-0 h-[calc(100%-1rem)] max-h-full`">
                    <transition name="dropdown">             
                        <div  :style="{ borderRadius: rounded }"  :class="`relative modal-inner modal_inner_dialog overscroll-none ${!disableScrolling ? 'overflow-x-hidden overflow-y-auto' : '' } w-full max-w-${size} max-h-full`.trim()">
                            <!-- Modal content -->
                            <div :style="{ borderRadius: rounded }" :class="` relative rtl bg-white  overflow-hidden `">
                                <!-- Modal header -->
                                <div :class="`flex w-full justify-between items-center p-4 rounded-t  ${!hideHeadersBorder ? 'border-b' : ''}`.trim()">
                                    <div v-if="centeredTitle" />
                                    <h3 :class="`${smallTitle ? 'text-lg' : 'text-xl'} font-semibold text-gray-900 `.trim()">
                                        {{ modalTitle }}
                                    </h3>
                                    <button @click="() => changeModalState(false)" type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex items-center">
                                        <img :src="timesIcon" alt="" width="19" height="19" class="h-[17px] w-[17px] md:h-[18px] md:w-[18px] lg:h-[19px] lg:w-[19px]" />
                                    </button>
                                </div>
                                <!-- Modal body -->
                                <slot/>
                            </div>
                        </div>
                    </transition>

                </div>
            </div>
    </div>
</template>

<script>
import timesIcon from "@/assets/icons/times.svg";
export default {
    data(){
        return {
            timesIcon
        }
    },
    props: {
        changeModalState: {
            type: Function,
            required: true,
        },
        hideHeadersBorder: {
            type: Boolean,
            default: false,
            required: false
        },
        disableScrolling: {
            type: Boolean,
            default: false,
            required: false
        },
        centeredTitle:{
            type: Boolean,
            default: false,
            required: false
        },
        smallTitle: {
            type: Boolean,
            default: false,
            required: false
        },
        isOpen: {
            type: Boolean,
            default: false,
            required: true
        },
        modalTitle: {
            type: String,
            default: "",
            required: true
        },
        modalClass: { //use this if you have multiple modals opening together in one page
            type: String,
            default: "static_modal",
            required: false
        },
        size: {
            type: String,
            default: "2xl",
            required: false 
        },
        rounded: {
            type: String,
            default: "10px",
            required: false 
        },
        modalStyleIndex: {
            type: String,
            default: "200",
            required: false
        },
        closeOnBackdropClick: {
            type: Boolean,
            default: true,
            required: false
        }

    },
    methods: {
        onClicking(event){
            var target = event.target || event.srcElement || event.currentTarget;
            if (target == document.querySelector(`.${this.modalClass}`) && this.closeOnBackdropClick){
                this.changeModalState(false);
            }
        }
    }
}
</script>

<style scoped>

#staticModal{
    position: fixed;
    inset:0;
    max-height: 100vh;
    max-height: 100svh;
    width: 100%;
    z-index: 200;
}
</style>